var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWateringCan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.24 56.58 410.55 65.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M411.745 76.2867C390.452 50.9135 298.235 69.1464 275.736 92.7871C190.235 116.646 4.98395 97.3779 1.23615 121.787L411.745 121.787L411.745 76.2867Z",
    fill: "#EFB0CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.324 59.5174C390.789 64.9411 391.444 66.8585 391.487 70.9337C393.649 73.8782 397.689 77.8084 396.555 69.9734C395.42 62.1384 403.634 61.1552 407.762 62.1628C409.373 62.556 410.682 63.0958 411.789 63.777L411.789 58.2876C406.007 55.672 399.878 56.0349 396.324 59.5174Z",
    fill: "#EFB0CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M411.789 103.427C409.315 107.014 406.552 110.099 404.396 111.362C403.732 114.42 402.528 119.657 402.908 121.788L405.144 121.788C405.446 121.489 405.782 121.114 406.157 120.654C408.227 118.844 410.1 116.998 411.789 115.129L411.789 103.427Z",
    fill: "#EFB0CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.52 75.7257L364.733 82.127L372.247 121.787L407.246 121.787L398.52 75.7257Z",
    fill: "#EFB0CA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 361.078,
    y: 76.6943,
    width: 39.5461,
    height: 8.59698,
    rx: 4,
    transform: "rotate(-10.728 361.078 76.6943)",
    fill: "#EFB0CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.621 82.7559C362.594 82.615 362.688 82.4793 362.829 82.4539L393.555 76.924L397.528 76.1714L399.514 75.795C400.449 75.6178 401.186 76.5845 400.766 77.439V77.439C400.606 77.7654 400.301 77.9974 399.944 78.0651L395.404 78.9252L365.977 84.773C364.636 85.0395 363.292 84.332 362.752 83.0759L362.637 82.8098C362.63 82.7925 362.625 82.7744 362.621 82.7559V82.7559Z",
    fill: "#EFB0CA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M375.46 115.941L326.063 96.1989L323.016 102.094L361.122 121.788L374.511 121.788L375.46 115.941Z",
    fill: "#EFB0CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.742 87.8691L324.687 89.5755L327.48 98.2768L325.603 102.617L317.691 105.751L313.746 104.045L320.742 87.8691Z",
    fill: "#EFB0CA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.951 99.2536L319.395 100.365L326.638 99.8743L325.572 102.452L317.66 105.587L313.715 103.88L315.951 99.2536Z",
    fill: "#EFB0CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M358.182 116.943L344.078 110.181L326.485 99.9187L325.496 102.458L361.741 121.827L370.66 121.827L358.182 116.943Z",
    fill: "#EFB0CA"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWateringCan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wateringCan.9cfe9394d16333960c2d276a16c9a362.svg";